import { useParams } from '@ksyos/router';
import { useEffect, useState } from 'react';
import { ManagerAuthorization } from '@common/enums';
import { Loading } from '@frontend/components/elements/common';
import { fetchJson } from '@frontend/store/fetch';
import { translateKey } from '@frontend/translate';
import { assertHasAuthorization } from '@frontend/utils';
import type { IInsurer } from '../../interfaces/insurer';
import { SideNavigationTemplate } from '../../templates/SideNavigationTemplate';
import { InsurerUzovisList } from '../insurerUzovis/InsurerUzovisList';
import { InsurerBlock } from './InsurerBlock';
import { InsurerServiceDeclarationRuleList } from './InsurerServiceDeclarationRuleList';

interface ITab {
    content: JSX.Element;
    name: string;
    title: string;
}

export function InsurerDetails() {
    const { id } = useParams() as { id: string };
    const [insurer, setInsurer] = useState<IInsurer | undefined>(undefined);

    assertHasAuthorization(ManagerAuthorization.insurersAddEdit);

    const tabs: ITab[] = [];
    if (insurer) {
        tabs.push({
            name: 'insurerUzovis',
            title: translateKey('insurers.linkedUzovis'),
            content: <InsurerUzovisList insurerId={insurer.id} />,
        });

        tabs.push({
            name: 'declarationRules',
            title: translateKey('serviceDeclarationRules.serviceDeclarationRules'),
            content: <InsurerServiceDeclarationRuleList insurerId={insurer.id} />,
        });
    }

    useEffect(() => {
        loadInsurerDetails();
    }, []);

    return (
        <Loading
            item={insurer}
            loaded={(item) => (
                <SideNavigationTemplate
                    breadcrumb={[
                        { text: translateKey('common.settings') },
                        { text: translateKey('insurers.insurers'), url: '/insurers' },
                        { text: insurer ? insurer.name : '' },
                    ]}
                    infoBlock={<InsurerBlock insurer={item} />}
                    tabs={tabs}
                />
            )}
        />
    );

    async function loadInsurerDetails() {
        const response = await fetchJson(`/api/insurers/${id}`, 'GET');
        setInsurer(response.json);
    }
}
